import { useTranslation } from "react-i18next";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import JsonLd from "@/components/feature/JsonLd";
import Hero from "./components/Hero";
import CategorySection from "./components/CategorySection";
import ArticleSection from "./components/ArticleSection";
import ResourcesSection from "./components/ResourcesSection";
import WhyComparison from "./components/WhyComparison";
import SafetyCta from "./components/SafetyCta";
import FaqSection from "./components/FaqSection";
import { SITE_NAME, SITE_LOGO_URL } from "@/mocks/seo";
import { useRouteLanguage, useLocalizedLinks } from "@/hooks/useLocale";

export default function Home() {
  const { t } = useTranslation();
  useRouteLanguage();
  const { lang } = useLocalizedLinks();
  const siteUrl = import.meta.env.VITE_SITE_URL || "https://usfanssheet.live";

  const websiteJsonLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: SITE_NAME,
    url: siteUrl,
    inLanguage: lang,
    description: t("hero.subtitle"),
    publisher: {
      "@type": "Organization",
      name: SITE_NAME,
      logo: { "@type": "ImageObject", url: SITE_LOGO_URL },
    },
  };

  const organizationJsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: SITE_NAME,
    url: siteUrl,
    logo: { "@type": "ImageObject", url: SITE_LOGO_URL },
  };

  return (
    <>
      <JsonLd data={[websiteJsonLd, organizationJsonLd]} />
      <Header />
      <main>
        <Hero />
        <CategorySection />
        <ArticleSection />
        <ResourcesSection />
        <WhyComparison />
        <SafetyCta />
        <FaqSection />
      </main>
      <Footer />
    </>
  );
}